import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { api } from "../../lib/adventureApi";
import VideoReviewCard from "./VideoReviewCard";

export default function VideoReviewsStrip() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/video-reviews", { params: { limit: 4 } }).then((r) => setItems(r.data)).catch(() => {}); }, []);
  if (!items.length) return null;

  return (
    <section className="max-w-7xl mx-auto px-5 sm:px-8 pt-20" data-testid="home-video-reviews">
      <div className="flex flex-wrap items-baseline justify-between gap-2 mb-8">
        <div>
          <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-terracotta mb-2">In their own words</p>
          <h2 className="font-display font-bold text-2xl sm:text-3xl tracking-tight">Video reviews from our travellers</h2>
        </div>
        <Link to="/reviews" data-testid="home-video-reviews-all"
          className="font-mono text-xs uppercase tracking-widest text-terracotta hover:underline flex items-center gap-1">
          See all <ArrowRight className="w-3.5 h-3.5" />
        </Link>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5">
        {items.map((r) => <VideoReviewCard key={r.token} review={r} />)}
      </div>
    </section>
  );
}
